import { Box, LinearProgress } from "@mui/material";

export default function LinearProgressComponent() {
    return (
        <Box sx={{ overflow: "hidden", width: '100%', backgroundColor: "#fff", paddingBottom: "3px", borderRadius: "10px 10px 0px 0px" }}>
            <LinearProgress />
        </Box>
    )
}